// extracted by mini-css-extract-plugin
module.exports = {"ctadisclosurechff":"ctadisclaimerchff-module--ctadisclosurechff","bold":"ctadisclaimerchff-module--bold"};